import styled from 'styled-components';
import { Form, Modal } from 'antd';

export const Root = styled(Modal)`
  & .ant-modal-content {
    background: #fff;
    border-radius: 5px;
    border: 1px solid #cecece;
  }

  & .ant-modal-header {
    padding: 2rem;
  }

  & .ant-modal-body {
    padding: 1rem 2rem 2rem;
  }

  & .ant-form-item {
    margin-bottom: 14px;
  }
`;

export const FormStyled = styled(Form)``;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-family: ToyotaDisplay;
  font-size: 24px;
  line-height: 30px;
  color: #000;
  margin: 0;
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  width: 100%;
`;

export const ErrorMessage = styled.p`
  color: red;
`;

export const HiddenContainer = styled.div`
  position: relative;
`;

export const HiddenItem = styled.div`
  position: absolute;
  opacity: 0;
`;

export const DraggerContainer = styled.div`
  margin: 20px 0;
  position: relative;
  transition: .2s linear all;
  
  ${({ hide }) => hide && `
       height: 50px;
  `}
  
  .ant-upload.ant-upload-drag{
      border: 1px solid #000000;
      box-sizing: border-box;
      border-radius: 5px;
      
      ${({ hide }) => hide && `
        z-index: -1;
      `}
  }
  
  .ant-upload-list-item.ant-upload-list-item-undefined.ant-upload-list-item-list-type-text {
    position: absolute;
    top: 0;
    left: 0;
  }
  
  p {
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 28px;
      line-height: 38px;
      color: #7B7B7B;
  }
  
  button {
    width: 293px;
    height: 62px;
    padding-bottom: 0 !important;
    padding-top: 0 !important;
    span {
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 28px;
      line-height: 38px;
    }
  }
`;
